import entering from './entering';
import enteringAudit from './entering-audit';
import result from './result';
import resultAudit from './result-audit';

export default {
    entering,
    enteringAudit,
    result,
    resultAudit
}